module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.trip) ? _c('div', {
    class: {
      'active': _vm.active
    },
    attrs: {
      "id": "gallery"
    }
  }, [_c('a', {
    attrs: {
      "herf": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeGallery()
      }
    }
  }, [_c('img', {
    staticClass: "close-btn",
    attrs: {
      "src": require("../assets/times.png")
    }
  })]), _vm._v(" "), (_vm.active) ? _c('div', {
    staticClass: "slider",
    on: {
      "mouseenter": function($event) {
        _vm.paused = true
      },
      "mouseleave": function($event) {
        _vm.paused = false
      }
    }
  }, [(_vm.hasImages) ? _c('div', {
    staticClass: "slideNav"
  }, [_c('a', {
    staticClass: "prevNav",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevImg()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "nextNav",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextImg()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentDest.gallery), function(image, index) {
    return (_vm.active) ? _c('div', {
      staticClass: "slide",
      class: {
        'activeImage': _vm.activeImage === index
      }
    }, [_c('span', {
      staticClass: "helper"
    }), _vm._v(" "), _c('img', {
      staticClass: "responsive-img",
      attrs: {
        "src": image.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slideCap"
    }, [_c('h5', [_vm._v(_vm._s(image.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(image.caption))])])]) : _vm._e()
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5faab3c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 442
// module chunks = 1